







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { BFormCheckboxGroup, BFormCheckbox, BOverlay } from "bootstrap-vue";
import corporateClientModel from "@/api/corporate_client.model";

@Component({
	components: {
		BFormCheckboxGroup,
		BFormCheckbox,
		BOverlay,
	},
})
export default class FavoriteCorporatesSelector extends Vue {
	@Prop({ required: false }) solutionId?: string;
	@Prop({ required: false, default: () => [] }) initialSelected?: string[];
	@Prop({ required: false, default: () => [] }) data?: string[];

	selectedCorporates: string[] = [];
	corporateOptions: Array<{ text: string; value: string }> = [];
	isLoading = false;
	isInitialized = false;

	async mounted() {
		await this.loadCorporateClients();

		// Inicializar com data (do EntityField) ou initialSelected
		const initialData = this.data || this.initialSelected || [];

		if (initialData.length > 0) {
			this.selectedCorporates = [...initialData];
		}

		this.isInitialized = true;
	}

	async loadCorporateClients() {
		this.isLoading = true;
		try {
			const corporates = await corporateClientModel.search({});
			this.corporateOptions = corporates.map((corporate: any) => ({
				text: `${corporate.name}${corporate.cnpj ? ` (${corporate.cnpj})` : ""}`,
				value: corporate.id,
			}));
		} catch (error) {
			this.$bvToast.toast("Erro ao carregar clientes corporativos", {
				title: "Erro",
				variant: "danger",
				solid: true,
			});
		} finally {
			this.isLoading = false;
		}
	}

	confirmSelection() {
		// Atualizar o array data (passado por referência) antes de fechar
		if (this.data) {
			// Limpar array existente
			this.data.splice(0, this.data.length);
			// Adicionar novos valores
			this.data.push(...this.selectedCorporates);
		}

		// Emitir closeModal
		this.$emit("closeModal");
	}

	@Watch("data")
	onDataChange(newVal: string[]) {
		// Só atualiza selectedCorporates se ainda não foi inicializado
		// Isso evita sobrescrever a seleção manual do usuário
		if (!this.isInitialized && newVal) {
			this.selectedCorporates = [...newVal];
		}
	}

	@Watch("initialSelected")
	onInitialSelectedChange(newVal: string[]) {
		// Só atualiza selectedCorporates se ainda não foi inicializado
		// Isso evita sobrescrever a seleção manual do usuário
		if (!this.isInitialized && newVal) {
			this.selectedCorporates = [...newVal];
		}
	}

	// Método público para obter seleção atual
	getSelected(): string[] {
		return this.selectedCorporates;
	}

	// Método público para resetar seleção
	reset() {
		this.selectedCorporates = [];
	}
}
